import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';

const BackToDashboardBtn = () => {
  const { designation } = useAuth();

  return (
   
    <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
      <Link
        to={
          designation === "Owner" || designation === "Partner"
            ? "/dashboard"
            : `/${designation}dashboard`.toLowerCase()
        }
        className="d-flex align-items-center back-link"
      >
        <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
        <i className="icon-dashboard"></i>
        <h3 className="mb-0 fw-normal">Dashboard</h3>
      </Link>
    </div>
 
  )
}

export default BackToDashboardBtn